import { cloneRgObject as h, deepAddParent as R } from "@project-rouge/rg-core";
import { memo as S, useMemo as a, useRef as p, useEffect as w, Fragment as O } from "react";
import { useGetSvgBox as P } from "../../hooks/index3.js";
import { get2dPlanObjs as y } from "./index.js";
import { snapRotation as b } from "./index3.js";
import { SvgRgObject as B } from "./index6.js";
import { SvgScale as M } from "./index7.js";
import { useSvgResizer as j } from "./index10.js";
import { jsx as t, jsxs as k } from "react/jsx-runtime";
const z = 3, A = S(({
  obj: e,
  styles: n,
  showScale: d,
  filterBy: f,
  snapRotation: m,
  svgCallback: i
}) => {
  e = a(() => (e = h(e), R(e), m && b(e), e), [e, m]);
  const r = p(null), c = p(null), {
    scale: l
  } = j({
    containerRef: r,
    padding: [0, 0, z, 0]
  }), s = P({
    dependencies: [e],
    ref: c
  }), g = a(() => y({
    obj: e,
    visible: Object.keys(n),
    filterBy: f
  }), [e, n]);
  return w(() => {
    i && r.current && i(r.current.outerHTML);
  }), /* @__PURE__ */ t("svg", {
    ref: r,
    style: {
      display: "block"
    },
    width: "100%",
    height: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ k("g", {
      "data-name": "wrapper",
      children: [/* @__PURE__ */ t("g", {
        "data-name": "content",
        ref: c,
        children: g.map((u, v) => /* @__PURE__ */ t(O, {
          children: u.map((o, x) => /* @__PURE__ */ t(B, {
            obj: o.obj,
            mx: o.mx,
            ...n[o.obj.type],
            scale: l
          }, x))
        }, v))
      }), d && s && /* @__PURE__ */ t(M, {
        box: s
      })]
    })
  });
});
A.displayName = "SvgPlan";
export {
  A as SvgPlan
};
//# sourceMappingURL=index4.js.map
